import React, {Component} from "react";
import PropTypes from "prop-types";

import {XDiv,   XImg, XSpan} from "../Layout/Layout";
import XButton from "../Layout/XButton";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import {X,CheckSquare   ,XCircle,Loader,Edit} from "react-feather";
import { renderToString } from 'react-dom/server'

// Import Swiper styles
// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import 'swiper/components/zoom/zoom.scss';
import 'swiper/components/effect-fade/effect-fade.scss';



import ReactDOM from "react-dom";
import Child from "../Children/Child";
import Modal from "../Modal/Modal";

const  validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/bmp"
    ,"image/x-icon","image/svg+xml"];
const  imgType= ["gif", "jpeg", "jpg", "bmp", "png"];

const otherRoot = document.getElementById('other-root');
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

class  DropZone  extends Component{

    HuploadProgress=null;
    HchangeStateItem=null;

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.openSlider = false;
        this.dropEl=React.createRef();
        this.previewEl=React.createRef();
        this.inputEl=React.createRef();

        this.sliderModal=React.createRef();
        this.HchangeInput = this.changeInput.bind(this);

        this.state = {render:false};
        this.HopenFile = this.openFile.bind(this);
        this.HopenFolder = this.openFolder.bind(this);
        this.HreceivedFiles = this.receivedFiles.bind(this);

        this.HopenSlider = this.openingSlider.bind(this);
        this.HcloseSlider = this.closeSlider.bind(this);

        this.HdragEnter = this.dragEnter.bind(this);
        this.HdragExit = this.dragExit.bind(this);
        this.HdropFiles = this.dropFiles.bind(this);
        this.HdragOver = this.dragOver.bind(this);

        this.HimgOnLoad = this.imgOnLoad.bind(this);
        this.HuploadProgress=this.uploadProgress.bind(this);
        this.HchangeStateItem=this.changeStateItem.bind(this);
        this.HdeleteingItem = this.deleteingItem.bind(this);
        this.HeditingItem = this.editingItem.bind(this);

        this.listFiles = [];
        this.listPreview = [];

        this.props=props;
    }

    refresh(){
        let r=!this.state.render;
        this.setState({render:r});
    }

    dragEnter(e) {
        let c = "dragenter";
        if(! this.dropEl.current.classList.contains(c)){
            this.dropEl.current.classList.add(c);
        }
        return true;
    }

    dragExit(e) {
        let c = "dragenter"
        if(this.dropEl.current.classList.contains(c)){
            this.dropEl.current.classList.remove(c);
        }
        return true;
    }

    dragOver(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    dropFiles(e) {
        // Get all files that are dropped
        var dt = e.dataTransfer || (e.originalEvent && e.originalEvent.dataTransfer);
        let files = e.target.files || (dt && dt.files);
        this.receivedFiles(files);
        let c = "dragenter"
        if(this.dropEl.current.classList.contains(c)){
            this.dropEl.current.classList.remove(c);
        }
        e.stopPropagation();
        e.preventDefault();
        return true;
    }

    clear(){
        if (!this.props.isMultiple) {
            this.listPreview = [];
            this.listFiles = [];
        }
    }

    imgOnLoad(e){
        let img=e.currentTarget;
        let src=img.src;
        let item=img.parentNode;
        let id=item.id;
        let k=this.getFilesObjIdIndex(id);
        if (k!==false) {
            let w = item.getBoundingClientRect().width;
            let h = item.getBoundingClientRect().height;
            let canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            let ctx = canvas.getContext('2d');
            let height = img.naturalHeight;
            let width = img.naturalWidth;
            if (width > this.props.maxWidth || height > this.props.maxHeight) {
                this.listFiles[k].hasResized = true;
            }
            let x = 0;
            let y = 0;
            let w1 = w;
            let h1 = h;
            if (width >= w) {
                x = 0;
                w1 = w;
            } else {
                x = (w - width) / 2;
                w1 = width;
            }
            if (height >= h) {
                y = 0;
                h1 = h;
            } else {
                y = (h - height) / 2;
                h1 = height;
            }
            if (width >= w && height >= h) {
                h1 = Math.floor(w * (height / width));
                y = (h - h1) / 2;
            }
            ctx.drawImage(img, x, y, w1, h1);
            let srcN = canvas.toDataURL("image/png");
            window.URL.revokeObjectURL(src);
            canvas = null;
            img.onload = null;
            let imgRef=this.listFiles[k].imgRef;
            imgRef.current.setSrc(srcN);
            imgRef.current.clearOnLoad();
            imgRef.current.refresh();
            if(this.listFiles[k].state==="new") {
                let f = this.props.receivedFile;
                if (f !== null) {
                    if (f instanceof Function) {
                        f(id);
                    }
                }
            }
        }
    }

    async getFileData(callbackFun,fileId) {
        let index=this.getFilesObjIdIndex(fileId);
        if (index!==false) {
            let len = this.listFiles.length;
            if (index < len) {
                let f1 = this.listFiles[index];
                if(f1.isImag && f1.hasResized) {
                    let plugin=this;
                    let reader;
                    let readerPromise = new Promise((resolve, reject) => {
                        reader = new FileReader();
                        reader.onload =    function (event) {
                            let img = new Image();
                            img.onload = function () {
                                let canvas = document.createElement('canvas');
                                let width = img.width;
                                let height = img.height;
                                if (width > height) {
                                    if (width > plugin.props.maxWidth) {
                                        height *= plugin.props.maxWidth / width;
                                        width = plugin.props.maxWidth;
                                    }
                                } else {
                                    if (height > plugin.props.maxHeight) {
                                        width *= plugin.props.maxHeight / height;
                                        height = plugin.props.maxHeight;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                let ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                canvas.toBlob(   function (blob) {
                                    let file1 = new File([blob], f1.file.name, {
                                        type: f1.type,
                                        lastModified: new Date()
                                    });
                                    if (callbackFun !== null) {
                                        if (callbackFun instanceof Function) {
                                             callbackFun(file1, fileId);
                                        }
                                    }
                                }, f1.type);
                                resolve(true);
                            }
                            img.src =  event.target.result;
                        };
                        reader.readAsDataURL(f1.file);
                    });
                    await readerPromise;
                }else{
                    let file1 = new File([f1.file], f1.file.name, {
                        type: f1.type,
                        lastModified: new Date()
                    });
                    if (callbackFun !== null) {
                        if (callbackFun instanceof Function) {
                            await callbackFun(file1, fileId);
                        }
                    }
                }
            }
        }
    };

    receivedFiles(files) {
        if (files.length>0) {
            let type = "";
            let src = "";
            this.clear();

            let numF = files.length;
            let tNum = this.listFiles.length;
            if ((tNum + numF) > this.props.maxFiles) {
                numF = this.props.maxFiles - tNum;
            }
            let idTag ;
            let isImag;
            for (let i = 0; i < numF; i++) {
                type = files[i].type;
                if (this.props.validTypes.includes(type)) {
                    let id = this.getRandomInt(1000000);
                    while (this.checkFilesHasObjId(id)) {
                        id = this.getRandomInt(1000000);
                    }
                    isImag = false;
                    idTag = 'item' + id;
                    if (validImageTypes.includes(type)) {
                        src = window.URL.createObjectURL(files[i]);
                        isImag = true;
                    }
                    this.addFileItem(id,idTag,type,src,src,src,"0",files[i].name,files[i].size,files[i],false);
                    if ( !isImag) {
                        let f = this.props.receivedFile;
                        if (f !== null) {
                            if (f instanceof Function) {
                                f(id);
                            }
                        }
                    }
                }
            }
            let r=!this.state.render;
            this.setState({render:r});
        }
    }

    editingItem(event){
        event.preventDefault();
        event.stopPropagation();
        let item=event.currentTarget.parentNode.parentNode;
        let id=item.id;
        let k=this.getFilesObjIdIndex(id);
        if (k!==false) {
            let f= this.props.editingItem;
            if(f!==null){
                if( f instanceof Function) {
                    f(this.listFiles[k]);
                }
            }
        }
        return false;
    }

    deleteingItem(event){
        event.preventDefault();
        event.stopPropagation();
        let item=event.currentTarget.parentNode.parentNode;
        let id=item.id;
        let k=this.getFilesObjIdIndex(id);
        if (k!==false) {
            let f= this.props.deleteingItem;
            if(f!==null){
                if( f instanceof Function) {
                    f(this.listFiles[k]);
                }
            }
        }
        return false;
    }

    deleteItem(id){
        let k=this.getFilesObjIdIndex(id);
        if (k!==false) {
            if (k > -1) {
                this.listFiles.splice(k, 1);
            }
        }
        let idstr=id.toString();
        for ( k in this.listPreview) {
            if(this.listPreview[k].key.toString()===idstr){
                this.listPreview.splice(k, 1);
                this.refresh();
                break;
            }
        }
    }

    deleteAll(){
        let idstr;
        let k;
        let j;
        for (k in this.listFiles) {
            if(this.listFiles[k].state!=="uploading"){
                idstr=this.listFiles[k].id.toString();
                this.listFiles.splice(k, 1);
                for ( j in this.listPreview) {
                    if(this.listPreview[j].key.toString()===idstr){
                        this.listPreview.splice(j, 1);
                        break;
                    }
                }
            }
        }
        this.refresh();
    }

    addFileItem(id,idTag,type,src="",srcOrginal="",srcThumbs="",dataId=0,name="",size=0,
                file=null,hasResized=false,state= "new") {
        let isImag = false;
        let imgRef = null;
        let img = null;
        if (validImageTypes.includes(type) || imgType.includes(type)) {
            isImag = true;
            imgRef = React.createRef();
            img = <XImg crossOrigin="anonymous" src={src} ref={imgRef} onLoad={this.HimgOnLoad}/>;
        }
        let fileObj = {
            isImag: isImag, hasResized: hasResized, imgRef: imgRef, dataId: dataId,
            id: id, idTag: idTag, type: type, src: src, state: state, file: file,srcOrginal:srcOrginal,srcThumbs:srcThumbs
        };
        this.listFiles.push(fileObj);
        let titleClass = "title ";
        if (!isImag) {
            titleClass = titleClass + " noImg";
        }

        let str = Math.floor(size / 1024) + " KB";
        let s1 = <XDiv><XSpan>{str}</XSpan></XDiv>;
        let s2 = <XDiv><XSpan>{name}</XSpan></XDiv>;
        let s3 = <XDiv><XSpan>{type}</XSpan></XDiv>;
        let spinner=null;
        if (state === "new") {
            spinner =<div className='ok' ><Loader /></div>;
        }
        let progress = <XDiv className="progress">{spinner}</XDiv>;
        let titleItem = <XDiv className={titleClass}>{s1} {s2} {s3} </XDiv>;
        let btnDelete = <XButton type="button" className="filesUpload-btn-delete" onClick={this.HdeleteingItem}>  <X  size={16} /> </XButton>;
        let btnEdit = null;
        if (this.props.isEdit) {
            btnEdit = <XButton type="button" className="filesUpload-btn-edit" onClick={this.HeditingItem}><Edit /></XButton>;
        }
        let btnGroup = <XDiv className="filesUpload-btn-group"> {btnDelete} {btnEdit} </XDiv>;
        let item = <XDiv key={id} attrs={{idtag: idTag}} id={id.toString()}
                         className="item">{img}{titleItem}{progress} {btnGroup}</XDiv>;
        this.listPreview.push(item);

    }

    uploadProgress(progressEvent,fileId){
        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        let k=this.getFilesObjIdIndex(fileId);
        if (k!==false){
            let idTag=this.listFiles[k].idTag;
            let items =  this.previewEl.current.querySelectorAll("[idtag='"+idTag+"']  .progress>._loader>.percent");
            items.forEach(function (item) {
                item.textContent= percentCompleted+"%";
            });
        }
    }

    changeStateItem  (id,state,dataId=null,src=null) {
        let k=this.getFilesObjIdIndex(id);
        if (k!==false){
            this.listFiles[k].state=state;
            if(dataId!==null){
                this.listFiles[k].dataId=dataId;
            }
            if(src!==null){
                this.listFiles[k].src=src;
                let imgRef=this.listFiles[k].imgRef;
                if(imgRef!==null){
                    if(imgRef.current!==null){
                        imgRef.current.setSrc(src);
                        imgRef.current.setOnLoad(this.HimgOnLoad);
                        imgRef.current.refresh();
                    }
                }
            }
            let idTag=this.listFiles[k].idTag;
            let f =  this.previewEl.current.querySelectorAll("[idtag='"+idTag+"']");
            if(f.length>0) {
                let item = f[0];
                switch (state) {
                    case "new": {
                        item.classList.add("new");
                        break;
                    }
                    case "uploading": {
                        item.classList.add("uploading");
                        let p =  item.querySelectorAll(".progress");
                        if(p.length>0) {
                            p[0].innerHTML="<div class='_loader' ><div class='percent' ></div><div class='circle-loader'></div></div>";
                        }
                        break;
                    }
                    case "uploaded": {
                        item.classList.remove("uploading");
                        item.classList.add("uploaded");
                        let p =  item.querySelectorAll(".progress");
                        if(p.length>0) {
                            p[0].innerHTML=renderToString(<div className='ok text-center'><CheckSquare className="  mt-2"  /></div> )  ;
                        }
                        break;
                    }
                    case "cancel": {
                        item.classList.remove("uploading");
                        item.classList.add("show");
                        let p =  item.querySelectorAll(".progress");
                        if(p.length>0) {
                            p[0].innerHTML=renderToString(<div className='cancel'><XCircle className="ml-3 mt-1"   /></div> )  ;
                        }
                        break;
                    }
                    default:
                        break;
                }
            }
        }
    };

    checkFilesHasObjId = function (id) {
        let res=false;
        for (let k in this.listFiles) {
            if(this.listFiles[k].id===id){
                res=true;
                break;
            }
        }
        return res;
    };

    getFilesObjIdIndex = function (id) {
        let res=false;
        for (let k in this.listFiles) {
            if(this.listFiles[k].id.toString()===id.toString()){
                res=k;
                break;
            }
        }
        return res;
    };

    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }

    openFile(event) {
        event.preventDefault();
        event.stopPropagation();
        this.inputEl.current.removeAttribute("directory");
        this.inputEl.current.removeAttribute("webkitdirectory");
        this.inputEl.current.removeAttribute("mozdirectory");
        this.inputEl.current.click();
        return false;
    }

    openFolder(event) {
        event.preventDefault();
        event.stopPropagation();
        this.inputEl.current.setAttribute("directory","");
        this.inputEl.current.setAttribute("webkitdirectory","");
        this.inputEl.current.setAttribute("mozdirectory","");
        this.inputEl.current.click();
        return false;
    }

    changeInput(event){
        let files = event.target.files;
        this.receivedFiles(files);
        if(this.props.isMultiple  ) {
            this.inputEl.current.value=null;
        }
    }

    async openingSlider(){
        this.openSlider = true;
        await this.refresh();
        this.sliderModal.current.open();
    }

    closeSlider(){
        this.openSlider = false;
        this.refresh();
    }

    renderPortal() {
        const {
            isSlider,
        } = this.props;

        if(isSlider &&  this.openSlider){
            let slides=[];
            let k;
            for (k in this.listFiles) {
                if(this.listFiles[k].state!=="uploading"){
                    if(this.listFiles[k].isImag){
                        slides.push(<SwiperSlide key={k} zoom={true}  ><img alt="" src={this.listFiles[k].srcOrginal}/></SwiperSlide>);
                    }
                }
            }

            return (
                <Modal ref={this.sliderModal}   hasScrollbar={true} isFullScreen={true} closeCallback={this.HcloseSlider} >
                    <Child type="header">
                        اسلایدر
                    </Child>
                    <Child type="body">
                        <Swiper effect="fade" navigation  pagination={{ clickable: true }}   >{slides}</Swiper>
                    </Child>
                </Modal> );
        }else return null;
    }

    render() {
        const {
            className,
            isDragDrop,
            isBtnDirectory,
            isSlider,
            isMultiple,
            openFileStr
        } = this.props;

        let c=`dropZone  ${className}`;

        let btnUpload=<XSpan className="filesUpload-btn" onClick={this.HopenFile}>
            {openFileStr}
        </XSpan>;
        let btnDirectory=null;
        if(isMultiple && isBtnDirectory) {
            btnDirectory=<XSpan className="filesUpload-btn" onClick={this.HopenFolder}>
                اپلود فولدر
            </XSpan>;
        }

        let btnSlider = null;
        if(isSlider){
            btnSlider=<XSpan className="filesUpload-btn float-left" onClick={this.HopenSlider}>
              نمایش اسلایدر
            </XSpan>;
        }

        let preview= <XDiv eleRef={this.previewEl} className="filesUpload preview" >{this.listPreview}</XDiv>;

        let drop=null;
        if(isDragDrop){
            drop= <XDiv className="drop" eleRef={this.dropEl}
                        onDragEnter={this.HdragEnter} onDragExit={this.HdragExit}
                        onDrop={this.HdropFiles} onDragOver={this.HdragOver} >
                {btnSlider}{btnUpload} {btnDirectory}{preview}
            </XDiv>;
        }else{
            drop= <> {btnSlider}{btnUpload}{btnDirectory}{preview}</> ;
        }

        return (
            <React.Fragment>
                <XDiv   className={c} >
                    <input onChange={this.HchangeInput} ref={this.inputEl} type="file"
                           autoComplete="off" multiple={isMultiple} className="hideInputFile"   />
                    {drop}
                </XDiv>
                {ReactDOM.createPortal(this.renderPortal(), otherRoot)}
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

DropZone.propTypes = {
    className: PropTypes.string,
    readOnly: PropTypes.bool,
    maxFiles: PropTypes.number,
    isEdit: PropTypes.bool,
    isDragDrop: PropTypes.bool,
    isBtnDirectory: PropTypes.bool,
    isMultiple: PropTypes.bool,
    isSlider: PropTypes.bool,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    receivedFile:  PropTypes.func,
    deleteingItem:PropTypes.func,
    editingItem:PropTypes.func,
    validTypes:PropTypes.arrayOf(PropTypes.string),
    openFileStr:PropTypes.string,
};

DropZone.defaultProps = {
    className:"",
    readOnly:false,
    maxFiles:10,
    isEdit:true,
    isDragDrop:true,
    isBtnDirectory:true,
    isSlider:false,
    isMultiple:true,
    maxWidth:1200,
    maxHeight:1200,
    validTypes:["image/gif", "image/jpeg", "image/png", "image/bmp","image/x-icon","image/svg+xml"],
    //validTypes:["application/x-rar-compressed", "application/octet-stream","application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip"],
    openFileStr:" اپلود فایل ها"
};

export default DropZone;

